<template>
  <div class="animated fadeIn">

    <div class="card">
      <div class="card-header">
        List of catalogs
      </div>
      <div class="card-body">
        <span v-if="isLoading">Loading..</span>
        <span v-if="(!products || products.length === 0) && !isLoading">No catalogs</span>
        <table class="table table-hover table-bordered" v-if="products && products.length">
          <thead class="thead-dark">
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Update</th>
              <th scope="col">Version</th>
              <th scope="col">Owner</th>
              <th scope="col">Status</th>
              <th scope="col">Created</th>
              <th scope="col">Price</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody v-for="productUpdate in products">
            <tr :key="product._id" v-for="(product, index) in productUpdate[1]">
              <td>
                <span v-if="index === 0 || productUpdate[0] === 'undefined'">{{ product.name }}</span>
                <span v-else class="line-versions"></span>
              </td>
              <td>{{ product.technicalDetails.update }}</td>
              <td>{{ product.technicalDetails.version }}</td>
              <td>{{ product.author.nickname }}</td>
              <td>
                <span class="badge" :class="product.status.class">{{ product.status.label }}</span>
              </td>
              <td>{{ product.created | moment('YYYY-MM-DD') }}</td>
              <td>{{ product.price }}</td>
              <td class="text-center">
                <router-link :to="{ name: 'Product', params: { slug: product.slug }}">
                  <span class="fa fa-eye mr-2"></span>
                </router-link>
                <router-link :to="{ name: 'Edit App', params: { slug: product.slug }}">
                  <span class="fa fa-edit mr-2"></span>
                </router-link>
                <a href="#delete" @click="deleteAction = { showModal: true, product: product}">
                  <span class="fa fa-minus-circle text-danger"></span>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="confirm-app-modal">
          <modal v-if="deleteAction.showModal" @close="deleteAction.showModal = false">
            <h3 slot="header">Confirm delete Catalog</h3>
            <p slot="body">Are you sure you want to delete the selected catalog?</p>
            <div slot="footer">
              <a href="#" class="btn btn-outline-info" data-dismiss="modal" @click="deleteAction.showModal = false">Cancel</a>
              <a href="#" class="btn orange-btn-custom" data-dismiss="modal" @click="deleteProduct(deleteAction.product)">Delete Catalog</a>
            </div>
          </modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from 'vuex'
import Dialog from '@/components/Dialog'
const _ = require('lodash')

export default {
  name: 'ListProductAdmin',
  components: { 'modal': Dialog },
  data() {
    return {
      isLoading: true,
      products: null,
      deleteAction: {
        showModal: false,
        product: null
      }
    }
  },
  created: function() {
    this.fetchData().then(products => (this.products = this.populateProducts(products)))
  },
  computed: {
    ...Vuex.mapGetters(['currentUser'])
  },
  methods: {
    fetchData() {
      return this.$http
        .get('product/admin')
        .then(
          response => {
            this.isLoading = false
            return response.data
          },
          () => {
            this.isLoading = false
          }
        )
    },
    populateProducts(products) {
      const viewStatus = {
        'edit': { 'label': 'Editing', 'class': 'badge-warning rounded-pill' },
        'pending': { 'label': 'Waiting for approval', 'class': 'badge-info rounded-pill' },
        'declined': { 'label': 'Declined', 'class': 'badge-danger rounded-pill' },
        'approved': { 'label': 'Approved', 'class': 'badge-success rounded-pill' },
        'closed': { 'label': 'Closed', 'class': 'badge-secondary rounded-pill' }
      }
      // TODO: change this groupBy by lodash way
      products = products.reduce((groups, item) => {
        const val = item['slugRef']
        groups[val] = groups[val] || []
        groups[val].push(item)
        return groups
      }, {})
      // Convert Object To Array and sort it by last update
      products = Object.keys(products)
        .map(key => {
          products[key] = _.orderBy(products[key], 'technicalDetails.update', 'desc')
          return [key, products[key]]
        })
      // Prepare data for each product update set
      products.forEach(productsUpdateSet => {
        productsUpdateSet[1].forEach(product => {
          // prepare actions based on status
          product.actions = {
            'edit': (product.status === 'edit'),
            'update': (product.status === 'approved'),
            'delete': (product.status === 'declined' || product.status === 'closed')
          }
          product.price = product.price || 'Free'
          product.status = viewStatus[product.status]
        })
      })

      return products
    },
    deleteProduct(product) {
      // Hide Modal
      this.deleteAction.showModal = false
      this.$http.delete(`product/dev/${product.slug}`)
        .then(
          response => {
            this.fetchData().then(products => (this.products = this.populateProducts(products)))
          },
          () => {
            // error callback
            this.showErrorMessage('Sorry but an error occurred when submitting form')
          }
        )
    }
  }
}
</script>
<style scoped>
.fa {
  font-size: 16px;
}
.table tbody {
  border-top: 2px solid #dadae1 !important;
}
.table td .line-versions {
  width: 80%;
  height: 25px;
  border-bottom: 1px solid #dadae1;
  display: inline-block;
  border-left: 1px solid #dadae1;
  top: -12px;
  position: relative;
  right: -12px;
}
.badge-success{
    background-color: rgb(26, 146, 26);
    color: white;
  }
  .badge-danger{
    background-color: rgb(250, 243, 43);
    color: rgb(194, 188, 188);
  }
  .badge-warning{
    background-color: rgb(232, 133, 79);
    color: white;
  }
  .badge-info{
    background-color: rgb(77, 84, 215);
    color: white;
  }
  .badge-secondary{
    background-color: rgb(69, 70, 72);
    color: white;
  }
</style>
<style>
.badge {
  color: black;
}</style>


// WEBPACK FOOTER //
// src/admin/views/product/ListApp.vue